export default "__VITE_PUBLIC_ASSET__05d9b1c3__"